let _ = t => t,
  _t;
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H1 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from 'styled-components';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { CRM_SUITE_STARTER_BUNDLE } from 'self-service-api/constants/ApiNames';
import { GENERAL } from 'self-service-api/constants/UpgradeProducts';
import { suite } from 'self-service-api/core/utilities/links';
import breakpoint from '../constants/Breakpoints';
import { UPGRADE_CONFIG_CONTENT_GENERIC_SUITE_STARTER } from '../constants/ErrorBoundaryNames';
import { APP } from '../constants/tracking/App';
import { SCREENS } from '../constants/tracking/Locations';
import { withErrorBoundary } from './ErrorBoundary';
import { HubProductHeader } from './HubProductHeader';
import ResourceLinks from './ResourceLinks';
import UpgradePageMerchCard from './UpgradePageMerchCard';
import { getHasSeatPurchaseMotions } from './utils/getHasSeatPurchaseMotions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlexContainer = styled(UIFlex).withConfig({
  displayName: "UpgradeConfigContentGenericSuiteStarter__FlexContainer",
  componentId: "sc-1igow7d-0"
})(["z-index:1;padding-top:64px;", ";"], breakpoint.tablet(_t || (_t = _`
    padding-right: 48px;
    padding-left: 48px;
  `)));
const UpgradeConfigContentGenericSuiteStarter = ({
  upgradePointApiName,
  upgradeConfig,
  purchaseMotions,
  handlePurchaseMotionButtonClick
}) => {
  const upgradeData = {
    app: APP,
    screen: SCREENS.UPGRADE_PAGE,
    uniqueId: upgradeConfig.upgradeKey,
    upgradeProduct: ApiNameToUpgradeProductMap[upgradePointApiName] || GENERAL,
    apiName: upgradePointApiName,
    //The upgradeSource will always equal the upgradeKey in banners
    upgradeSource: upgradeConfig.upgradeKey,
    feature: upgradeConfig.feature
  };
  const hideHubProductHeader = getHasSeatPurchaseMotions(purchaseMotions);
  return /*#__PURE__*/_jsxs(FlexContainer, {
    justify: "between",
    align: "center",
    children: [/*#__PURE__*/_jsxs(UIBox, {
      grow: 1,
      basis: "50%",
      className: "p-right-4",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [!hideHubProductHeader && /*#__PURE__*/_jsx(HubProductHeader, {
          apiName: CRM_SUITE_STARTER_BUNDLE
        }), /*#__PURE__*/_jsx(H1, {
          className: "m-bottom-10",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ebxInterstitialPage.suiteStarterGenericContent.title"
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "text-left",
          "data-test-id": "upgrade-modal-subtitle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ebxInterstitialPage.suiteStarterGenericContent.subtitle"
          })
        }), /*#__PURE__*/_jsx(ResourceLinks, {
          upgradeConfig: upgradeConfig
        })]
      }), /*#__PURE__*/_jsx(UpgradePageMerchCard, {
        purchaseMotions: purchaseMotions,
        upgradeData: upgradeData,
        upgradePointApiName: upgradePointApiName,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
      })]
    }), /*#__PURE__*/_jsx(UIBox, {
      grow: 0,
      basis: "50%",
      className: "p-left-4",
      children: /*#__PURE__*/_jsx(UIIllustration, {
        name: "add-on-lead-flows",
        height: 450
      })
    })]
  });
};
export default withErrorBoundary(UpgradeConfigContentGenericSuiteStarter, {
  boundaryName: UPGRADE_CONFIG_CONTENT_GENERIC_SUITE_STARTER,
  redirectCallback: suite
});